<template>
  <v-card>
    <v-toolbar color="primary">
      <v-toolbar-title class="subheading white--text">
        ALTERAR ÍTEM
      </v-toolbar-title>
    </v-toolbar>
    <v-card-title class="titulo">
      <span color="primary"
        >{{ page === 1 ? "Veiculos" : "Cobertura" }}
        <small class="error--text" v-if="fipeInvalida">
          Não foi possível validar o item novo. Verifique a presença de erros no
          preenchimento dos campos marcados.</small
        >
      </span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text flex>
      <v-form ref="formulario" grid-list-lg class="content">
        <v-layout column v-if="page === 1">
          <v-layout row wrap pb-3>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Placa"
                v-model="veiculo.placa"
                :rules="regras.notNull"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="Chassi"
                v-model="veiculo.chassi"
                :rules="regras.notNull"
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="FIPE"
                v-model="veiculo.fipe"
                :mask="'######-#'"
                :error="fipeInvalida"
                :disabled="!alterarValores"
                return-masked-value
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="Marca"
                v-model="veiculo.marca"
                required
                :error="fipeInvalida"
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md3>
              <v-text-field
                label="Modelo"
                v-model="veiculo.modelo"
                required
                :maxlength="65"
                :counter="65"
                :error="fipeInvalida"
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap py-3>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.tipoVeiculoList"
                v-model="veiculo.tipoVeiculo"
                label="Tipo de Veiculos"
                item-text="titulo"
                :item-value="(item) => item"
                required
                :error="fipeInvalida"
                :disabled="!alterarValores"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.catVeiculoList"
                v-model="veiculo.catVeiculo"
                label="Categoria do Veículo"
                placeholder="Selecione uma opção"
                item-text="titulo"
                :item-value="(item) => item"
                :rules="regras.notNull"
                required
                :disabled="!alterarValores"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Ano Fabricação"
                v-model="veiculo.anoFab"
                :rules="regras.notNull"
                required
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-text-field
                label="Ano Modelo"
                v-model="veiculo.anoMod"
                :error="fipeInvalida"
                required
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-select
                :items="campos.ufPernoiteList"
                v-model="veiculo.ufPernoite"
                item-text="titulo"
                :item-value="(item) => item"
                label="UF Pernoite"
                required
                :disabled="!alterarValores"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.usoDoVeiculoList"
                v-model="veiculo.usoDoVeiculo"
                label="Uso do Veículo"
                placeholder="Selecione uma opção"
                item-text="titulo"
                :item-value="(item) => item"
                :rules="regras.notNull"
                required
                :disabled="!alterarValores"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap py-3>
            <v-flex xs12 sm5 md4>
              <v-select
                :items="campos.propriedadeRegistroDoCrlvList"
                v-model="veiculo.propriedadeRegistroDoCrlv"
                label="Propriedade (Registro do CRLV)"
                placeholder="Selecione uma opção"
                item-text="titulo"
                :item-value="(item) => item"
                :rules="regras.notNull"
                required
                :disabled="!alterarValores"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                class="body-1"
                label="Proprietário"
                v-model="veiculo.proprietario"
                :rules="regras.notNull"
                required
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                label="CPF/CNPJ"
                v-model="veiculo.cpfCnpj"
                :mask="
                  veiculo.cpfCnpj !== null && veiculo.cpfCnpj.length > 11
                    ? 'NN.NNN.NNN/NNNN-##'
                    : '###.###.###-###'
                "
                :rules="regras.notNull"
                required
                :disabled="!alterarValores"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md1>
              <v-radio-group
                height="50px"
                v-model="veiculo.chassiRemarcado"
                row
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1">Chassi Remarcado</span>
                <v-layout>
                  <v-flex
                    d-inline-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="!alterarValores"
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout wrap pt-3>
            <v-flex xs12 sm5 md1>
              <v-radio-group v-model="veiculo.zeroKm" class="my-0 pt-0">
                <span class="themeGrey--text body-1">Zero Km</span>
                <v-layout>
                  <v-flex
                    d-inline-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio
                      :label="item.titulo"
                      :value="item.value"
                      :disabled="!alterarValores"
                    >
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                :items="campos.diasGarantZeroKmList"
                label="Dias de Garantia Zero Km"
                placeholder="Selecione"
                v-model="veiculo.diasGarantZeroKm"
                item-text="titulo"
                :item-value="(item) => item"
                :disabled="!alterarValores"
              ></v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm4 md2>
              <v-menu
                ref="menu"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="textInicio"
                    label="Saída da Concessionária"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    required
                    :disabled="!alterarValores"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateInicio"
                  @change="onDateChange"
                  no-title
                  scrollable
                >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-card-actions class="pa-5">
      <v-spacer></v-spacer>
      <template v-if="page === 1">
        <v-btn color="primary" flat @click="fechar">Cancelar</v-btn>
        <v-btn
          class="button-custom"
          @click="adicionarItem() ? (page = 1) : null"
          flat
          >Salvar</v-btn
        >
      </template>
    </v-card-actions>
    <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Fechar</v-btn>
    </v-snackbar>
  </v-card>

</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import CustomFormat from "@/helpers/custom-format";
import { VMoney } from "v-money";
import mask from "@/helpers/mask";
import debounce from "@/helpers/debounce";

export default {
  name: "AlterarItemEndossoModal",
  directives: {
    money: VMoney,
  },
  data: () => {
    return {
      dateInicio: new Date().toISOString().slice(0, 10),
      page: 1,
      menu1: false,
      snack: false,
      snackColor: "",
      snackText: "",
      simOuNao: [
        {
          value: false,
          titulo: "Não",
        },
        {
          value: true,
          titulo: "Sim",
        },
      ],
      fipeInvalida: false,
      regras: {
        notNull: [(v) => !!v || "Você não pode deixar este campo em branco"],
        cnpj: [(v) => !!String(v).match(/^[A-Za-z0-9]{12}\d{2}$/) || "CNPJ incorreto"],
      },
      veiculo: {
        item: null,
        placa: null,
        chassi: null,
        fipe: null,
        marca: null,
        modelo: null,
        tipoVeiculo: {},
        catVeiculo: {},
        anoMod: null,
        anoFab: null,
        ufPernoite: null,
        usoDoVeiculo: null,
        propriedadeRegistroDoCrlv: null,
        proprietario: null,
        cpfCnpj: null,
        chassiRemarcado: false,
        zeroKm: false,
        diasGarantZeroKm: null,
        saidaDaConcessionaria: null,
        tipoCobertura: null,
        danosMateriais: null,
        danosCorporais: null,
        danosMoraisEEsteticos: null,
        danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado:
          null,
        appMorte: null,
        vlrDmDirigenteSociosEmpregadosPrepostos: 0,
        appInvalidez: null,
        despesasMedicasHospitalaresEOdontologicas: null,
        despesasExtras: null,
        garantiaUnica: false,
        vlrGarantiaUnica: 0.0,
        tipoDeContratacao: 1,
        percAjusteVmrOuVd: "0",
        tipoDeFranquia: null,
        tipoDeProposta: null,
        renovacaoComSinistro: null,
        classeBonus: null,
        numeroApoliceAnterior: null,
        numeroItemAnterior: null,
        ciaRenovacao: null,
        codRenovacao: null,
        caminhaoBasculado: false,
        vlrDeNovo180Dias: false,
        vlrDeNovo365Dias: false,
        garantiaCompreensivaParaTumultos: false,
        danosCorporaisADirigentesSociosEmpregadosEPrepostos: false,
        danosMateriaisADirigentesSociosEmpregadosEPrepostos: false,
        guDmDcADirigentesSociosEmpregadosEPrepostos: false,
        vlrGuDmDcADirigentesSociosEmpregadosEPrepostos: 0,
        extensaoDeCoberturaRcfAVeiculosRebocados: false,
        kmAssistencia: 0,
        carroReserva: null,
        vlrFipe: 0,
        vdContratado: 0,
        coberturaAdicionalCarroceria: false,
        coberturaAdicionalEquipamentos: false,
        coberturaAdicionalAcessorios: false,
        coberturaAdicionalDespesasExtras: false,
        descrCarroceria: null,
        vlrCarroceria: 0,
        descrEquipamentos: null,
        vlrEquipamentos: 0,
        descrAcessorios: null,
        vlrAcessorios: 0,
        vlrBlindagem: 0,
        vlrKitGas: 0,
        coberturaVidros: null,
        vlrExtensaoDeCoberturaRcfAVeiculosRebocados: 0,
        vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos: 0,
      },
      idApolice: null,
      veiculoAnterior: {},
      carregaVeiculoDebounced: () => {},
    };
  },
  props: {
    dialog: Boolean,
    item: Number,
    campos: Object,
    alterarValores: Boolean,
    placa: { type: String, required: false },
    chassi: { type: String, required: false },
    chassis: Array,
    modificacoes: { type: Object, required: false },
    numeroRevisao: Number,
    diferencaObjetos: { type: Boolean, required: false, default: false },
  },
  computed: {
    textInicio() {
      return new Date(this.dateInicio).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    maskComputed: function () {
      return mask;
    }

  },

  watch: {
    dateInicio: function() {
      return this.veiculo.saidaDaConcessionaria = this.dateInicio
    },
    "veiculo.vlrDmDirigenteSociosEmpregadosPrepostos": function (val) {
      return this.veiculo.vlrDmDirigenteSociosEmpregadosPrepostos === null || this.veiculo.vlrDmDirigenteSociosEmpregadosPrepostos === '' ?
       this.veiculo.vlrDmDirigenteSociosEmpregadosPrepostos = 0 : this.veiculo.vlrDmDirigenteSociosEmpregadosPrepostos
    },
    "veiculo.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos": function (val) {
      if(val != null && val !== '') {
        return this.veiculo.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos
      }
    },
    "veiculo.vlrExtensaoDeCoberturaRcfAVeiculosRebocados": function (val) {
      return this.veiculo.vlrExtensaoDeCoberturaRcfAVeiculosRebocados === null || this.veiculo.vlrExtensaoDeCoberturaRcfAVeiculosRebocados === '' ?
      this.veiculo.vlrExtensaoDeCoberturaRcfAVeiculosRebocados = 0 : this.veiculo.vlrExtensaoDeCoberturaRcfAVeiculosRebocados
    },
    "veiculo.vlrCarroceria": function (val) {
      return this.veiculo.vlrCarroceria === null || this.veiculo.vlrCarroceria === '' ?
       this.veiculo.vlrCarroceria = 0 : this.veiculo.vlrCarroceria
    },
    "veiculo.danosCorporais": function (val) {
      return this.veiculo.danosCorporais === null || this.veiculo.danosCorporais === ''
      ? this.veiculo.danosCorporais = 0 : this.veiculo.danosCorporais
    },
    "veiculo.danosMateriais": function (val) {
      return this.veiculo.danosMateriais === null || this.veiculo.danosMateriais === ''
      ? this.veiculo.danosMateriais = 0 : this.veiculo.danosMateriais
    },
    "veiculo.danosMoraisEEsteticos": function (val) {
     return this.veiculo.danosMoraisEEsteticos === null || this.veiculo.danosMoraisEEsteticos === ''
     ? this.veiculo.danosMoraisEEsteticos = 0 : this.veiculo.danosMoraisEEsteticos
    },
    "veiculo.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado" : function (val) {
      return this.veiculo.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado === null
      || this.veiculo.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado === '' ?
      this.veiculo.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado = 0 :
       this.veiculo.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
    },
    "veiculo.vlrEquipamentos" : function (val) {
      return this.veiculo.vlrEquipamentos === null || this.veiculo.vlrEquipamentos === '' ?
       this.veiculo.vlrEquipamentos = 0 : this.veiculo.vlrEquipamentos
    },
    "veiculo.vlrAcessorios" : function (val) {
      return this.veiculo.vlrAcessorios === null || this.veiculo.vlrAcessorios === '' ?
      this.veiculo.vlrAcessorios = 0 : this.veiculo.vlrAcessorios
    },
    "veiculo.placa": function (val) {
      if(val != null && this.veiculo.placa.length > 6 && this.veiculo.placa != this.placa ) {
        this.carregaVeiculo(val, null);

      }    },
     "veiculo.chassi": function (val) {
      if(val != null && this.veiculo.chassi.length > 16 && this.veiculo.chassi != this.chassi) {
        this.carregaVeiculo(null,val);

      }    },
    "veiculo.tipoCobertura": function (val) {
      this.carregaCamposCasoTipoCoberturaRCF(val);
    },
    "veiculo.tipoDeContratacao": function (val) {
      this.carregarTipoContratacao(val)
    },
    "veiculo.garantiaUnica": function (val) {
      this.carregarGarantiaUnica(val)
    },
    "veiculo.descrCarroceria":function (val) {
      this.carregarDescricaoCarroceria(val)
    },
    "veiculo.descrEquipamentos":function (val) {
      this.carregarDescricaoEquipamentos(val)
    },
     "veiculo.descrAcessorios":function (val) {
      this.carregarDescricaoAcessorio(val)
    },
    "veiculo.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos": function (val) {
      this.veiculo.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos == null ||
      this.veiculo.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos == "" ?
      this.veiculo.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos = 0 :
      this.veiculo.vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos
    },
    "veiculo.fipe":function (val) {
      if(val == null || val.trim() == "") {
        this.veiculo.fipe = null;
      }
    },

  },
  mounted() {
    this.idApolice = this.$route.query.id;
    if(this.chassi){
      this.veiculo.chassi = this.chassi;
    }

    if (this.placa) {
      this.veiculo.placa = this.placa;
    }

    if(this.item) {
      this.veiculo.item = this.item;
    }
    this.carregarVeiculoDaGrid(this.placa, this.chassi);


  },
  methods: {
    onDateChange: function() {
      this.dateInicio = this.corretor.dataVencimentoApolice;
    },
    carregarDescricaoAcessorio(val){
      if(val.id === 0){
        this.veiculo.vlrAcessorios = null
      }
    },
    carregarDescricaoCarroceria(val){
      if(val.id === 0){
        this.veiculo.vlrCarroceria = null
      }
    },
    carregarDescricaoEquipamentos(val){
      if(val.id === 0){
        this.veiculo.vlrEquipamentos = null
      }
    },
    carregarGarantiaUnica(val){
      if(val === false){
        this.veiculo.vlrGarantiaUnica = null
        this.veiculo.guDmDcADirigentesSociosEmpregadosEPrepostos = false
        this.veiculo.vlrGuDmDcADirigentesSociosEmpregadosEPrepostos = null
      }
    },
    carregarTipoContratacao(val){
      if(val === 0){
        this.veiculo.percAjusteVmrOuVd = null
      }
    },
    carregaCamposCasoTipoCoberturaRCF(val){
      if(val.id === 3){
        this.veiculo.tipoDeContratacao = null
        this.veiculo.percAjusteVmrOuVd = null
        this.veiculo.tipoDeFranquia = null
        this.veiculo.descrCarroceria = null
        this.veiculo.coberturaAdicionalCarroceria = false
        this.veiculo.coberturaAdicionalEquipamentos = false
        this.veiculo.coberturaAdicionalAcessorios = false
        this.veiculo.vlrCarroceria = 0
        this.veiculo.descrEquipamentos = null
        this.veiculo.vlrEquipamentos = 0
        this.veiculo.descrAcessorios = null
        this.veiculo.vlrAcessorios = 0

      }
    },
    async revalidaCamposFipe() {
      if (!this.$refs.formulario.validate()) {
        return;
      }
      const data = await axios
        .post(
          `${process.env.URL_PLANILHAMS}/v1/revalidarCamposPlanilha/`,
          [this.veiculo],
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => response.data)
        .catch(() => null);

      if (
        !(this.fipeInvalida = !(
          data instanceof Array &&
          data.length &&
          data[0].erro === false
        ))
      )
        this.page = 2;
    },

    carregaVeiculo(conteudoPlaca, conteudoChassi) {
      if ((conteudoPlaca && conteudoPlaca.length === 7) ||
          (conteudoChassi && conteudoChassi.length === 17)) {
        axios.get(
          `${process.env.URL_APOLICEMS}/v1/buscaVeiculo?idApolice=${this.idApolice}&placa=${conteudoPlaca}&chassi=${conteudoChassi}&item=${this.veiculo.item}&chassiAnterior=${this.veiculoAnterior.chassi}&placaAnterior=${this.veiculoAnterior.placa}`,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
              },
            }
          )
          .then((response) => {
              if (response.data) {
                Object.keys(this.veiculo).forEach((key) => {
                  this.veiculo[key] =
                    this.modificacoes && this.modificacoes[key]
                      ? this.modificacoes[key]
                      : response.data[key];
                });
              }
          });
      }
    },
    carregarVeiculoDaGrid(conteudoPlaca, conteudoChassi) {
      if ((conteudoPlaca && conteudoPlaca.length === 7) ||
          (conteudoChassi && conteudoChassi.length === 17)) {
        axios
          .get(
            `${process.env.URL_APOLICEMS}/v1/buscaVeiculo?idApolice=${this.idApolice}&placa=${conteudoPlaca}&chassi=${conteudoChassi}&item=${this.veiculo.item}`,
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
              },
            }
          )
          .then((response) => {
            if (response.data) {
              Object.keys(this.veiculo).forEach((key) => {
                this.veiculoAnterior[key] = response.data[key];
                this.veiculo[key] = this.veiculoAnterior[key];
              });

            }
          });
        }
    },
    retornarModificacoes() {
      if (this.diferencaObjetos) {
        const modificado = Object.entries(this.veiculo).reduce(
          (acc, [key, value]) =>
            value !== this.veiculoAnterior[key] && value !== ""
              ? { ...acc, [key]: value }
              : acc,
          {}
        );
        if (Object.keys(modificado).length) {
          return JSON.parse(JSON.stringify({
            ...modificado,
            item: this.veiculoAnterior.item || this.veiculo.item,
          }));
        }
      } else {
        return this.veiculo;
      }
    },

    adicionarItem() {

      this.save();
      setTimeout(() => {
        this.$emit("add", this.retornarModificacoes());
      }, 1600);
    },
    fechar() {
      this.$emit("fechar");
    },

    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Alteração salva";
    },
  },
};
</script>

<style>
.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff !important;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}

@media (min-width: 1440px) {
  .titulo {
    padding-left: 11rem;
  }
  .content {
    max-width: 1600px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/AlterarItemEndossoModal.vue